import React from 'react';

const About = () => (
  <div style={styles.container}>
    <h2 style={styles.title}>About Jaca</h2>
    <div style={styles.cardGrid}>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <i className="fas fa-users" style={styles.icon}></i>
        </div>
        <h3 style={styles.cardTitle}>Our Mission</h3>
        <p style={styles.cardContent}>
          Jaca connects you with trusted and expert STEM Coaches. We make finding and booking appointments easy, secure, and convenient.
        </p>
      </div>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <i className="fas fa-star" style={styles.icon}></i>
        </div>
        <h3 style={styles.cardTitle}>Why Choose Jaca?</h3>
        <ul style={styles.list}>
          <li>Verified and rated STEM coaches</li>
          <li>Easy booking and secure payments</li>
          <li>Responsive customer support</li>
          <li>Peace of mind with every appointment</li>
        </ul>
      </div>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <i className="fas fa-heart" style={styles.icon}></i>
        </div>
        <h3 style={styles.cardTitle}>Our Values</h3>
        <p style={styles.cardContent}>
          We value quality, transparency, and customer satisfaction. Our team is dedicated to making your experience seamless and enjoyable.
        </p>
      </div>
    </div>
    <div style={styles.bottom}>
      <p>
        Thank you for choosing <strong>Jaca</strong>. We look forward to serving you!
      </p>
    </div>
  </div>
);

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
  },
  title: {
    marginBottom: '32px',
    color: '#4078c0',
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '28px',
    marginBottom: '32px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(64,120,192,0.08)',
    padding: '28px 18px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '180px',
  },
  iconCircle: {
    background: '#4078c0',
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '14px',
  },
  icon: {
    color: '#fff',
    fontSize: '1.7rem',
  },
  cardTitle: {
    fontSize: '1.15rem',
    fontWeight: 'bold',
    color: '#8d6e36',
    marginBottom: '10px',
    marginTop: '2px',
  },
  cardContent: {
    fontSize: '1rem',
    color: '#333',
    lineHeight: '1.6',
  },
  list: {
    textAlign: 'left',
    margin: '0 auto',
    paddingLeft: '18px',
    color: '#333',
    fontSize: '1rem',
    lineHeight: '1.7',
  },
  bottom: {
    marginTop: '18px',
    textAlign: 'center',
    fontSize: '1.08rem',
    color: '#555',
  },
};

export default About;